import React, {useEffect} from "react";
import ProductsCarousel from "./Columns/ProductsCarousel";
import {getRecentlyViewed} from "../actionCreators/pdpAC";
import {useDispatch, useSelector} from "react-redux";

const RecentlyViewed = () =>  {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getRecentlyViewed());
    }, [])

    const recently_viewed_products = useSelector(state => state.shopifyReducer.recently_viewed_products);

    if(recently_viewed_products.length > 0) {
        const next_props = {
            products: recently_viewed_products,
            title: "Recently Viewed",
            alt_prefix: "Recently Viewed: ",
            custom_class: "products-carousel__recently-viewed",
            render_type: "recently_viewed",
        }
        return (
            <ProductsCarousel {...next_props} />
        )
    }

    return null;
}

export default RecentlyViewed;